import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  const dateFormat = props.dateFormat || "dd.MM.yyyy";
  const showTimeSelect = props.showTimeSelect || false;
  return (
    <DatePicker
      {...field}
      {...props}
      showTimeSelect={showTimeSelect}
      timeFormat="HH:mm"
      dateFormat={dateFormat}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
      }}
    />
  );
};

export default DatePickerField;
